let failedAxiosUrl;
const prepareAxiosErrorDataInterceptor = (sentryEnabled)=>(error)=>{
        if (sentryEnabled && error?.isAxiosError) failedAxiosUrl = error.config.url;
    };
const pushAxiosDataToSentry = (event)=>{
    if (failedAxiosUrl) {
        if (!event.extra) event.extra = {};
        if (!event.tags) event.tags = {};
        event.extra.failedAxiosUrl = failedAxiosUrl;
        event.tags.failedAxiosUrl = failedAxiosUrl;
        failedAxiosUrl = void 0;
    }
    return event;
};
const pushAxiosDataToSentry_rslib_entry_ = pushAxiosDataToSentry;
export { pushAxiosDataToSentry_rslib_entry_ as default, prepareAxiosErrorDataInterceptor };

//# sourceMappingURL=pushAxiosDataToSentry.mjs.map